export const VendorDetailConstant = {

    
    VENDOR_DETAIL_SAGA: "VENDOR_DETAIL_SAGA",
    VENDOR_DETAIL_REQUEST: "VENDOR_DETAIL_REQUEST",
    VENDOR_DETAIL_RESPONSE: "VENDOR_DETAIL_RESPONSE",
    VENDOR_DETAIL_API: "/vendor/details",

    CHARGING_ENABLE_DISABLE_SAGA: "CHARGING_ENABLE_DISABLE_SAGA",
    CHARGING_ENABLE_DISABLE_REQUEST: "CHARGING_ENABLE_DISABLE_REQUEST",
    CHARGING_ENABLE_DISABLE_RESPONSE: "CHARGING_ENABLE_DISABLE_RESPONSE",
    CHARGING_ENABLE_DISABLE_API: "/charging-point/enable-disable-connector",

    CHARGING_POINT_DELETE_SAGA: "CHARGING_POINT_DELETE",
    CHARGING_POINT_DELETE_REQUEST: "CHARGING_POINT_DELETE_REQUEST",
    CHARGING_POINT_DELETE_RESPONSE: "CHARGING_POINT_DELETE_RESPONSE",
    CHARGING_POINT_DELETE_API: "/charging-point/delete-connector/:id",



    CHARGING_POINT_ENABLE_DISABLE_SAGA: ".CHARGING_POINT_ENABLE_DISABLE_SAGA",
    CHARGING_POINT_ENABLE_DISABLE_REQUEST: "CHARGING_ENABLE_DISABLE_REQUEST",
    CHARGING_POINT_ENABLE_DISABLE_RESPONSE: "CHARGING_ENABLE_DISABLE_RESPONSE",
    CHARGING_POINT_ENABLE_DISABLE_API: "/enable-disable-chargingpoint",



// for request view vendor detail page 

    GET_REQUEST_VIEW_VENDOR_DETAILS_SAGA: "GET_REQUEST_VIEW_VENDOR_DETAILS_SAGA",
    GET_REQUEST_VIEW_VENDOR_DETAILS_REQUEST: "GET_REQUEST_VIEW_VENDOR_DETAILS_REQUEST",
    GET_REQUEST_VIEW_VENDOR_DETAILS_RESPONSE: "GET_REQUEST_VIEW_VENDOR_DETAILS_RESPONSE",
    GET_REQUEST_VIEW_VENDOR_DETAILS_API: "/vendor/charging-station/",
};